import { render, staticRenderFns } from "./DialogSuccess.vue?vue&type=template&id=4ebe9084&scoped=true"
import script from "./DialogSuccess.vue?vue&type=script&lang=js"
export * from "./DialogSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebe9084",
  null
  
)

export default component.exports